import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import translationSGEN from './content/sg/en.json';
import { DEBUG_TRANSLATION, DEFAULT_LANGUAGE, ROUTES } from './constants';
import { getCountrySpecificDetails, getAllowedCountries, getAllowedLanguages } from './apis/utils/user/login';

// Construct the URL dynamically
const locationPath = window.location.pathname;
const parts = locationPath.split('/');
const countryLanguageCodeWithPath = {
    countryCode: parts[1],
    languageCode: parts[2],
    path: parts[3]
};
const countrySpecificDetails = getCountrySpecificDetails(countryLanguageCodeWithPath, 'all');

const batchCode = countrySpecificDetails?.[countryLanguageCodeWithPath.countryCode]?.[countryLanguageCodeWithPath.languageCode]?.batch_code

if (locationPath.includes(ROUTES.NOTFOUND) || locationPath.includes(ROUTES.PING)) {
    /* empty */ // - This is to stop again and agin whether the page contain both country and language code or not
} else if (getAllowedCountries(countrySpecificDetails).includes(countryLanguageCodeWithPath.countryCode) && !getAllowedLanguages(countrySpecificDetails).includes(countryLanguageCodeWithPath.languageCode)) {
    window.location.href = `/${countryLanguageCodeWithPath.countryCode}${ROUTES.NOTFOUND}`;
} else if (!batchCode || !getAllowedCountries(countrySpecificDetails).includes(countryLanguageCodeWithPath.countryCode) || !getAllowedLanguages(countrySpecificDetails).includes(countryLanguageCodeWithPath.languageCode)) {
    window.location.href = ROUTES.NOTFOUND;
}

// Function to load translations dynamically
async function loadTranslations(countryCode, languageCode) {
    try {
        const module = await import(`./content/${countryCode}/${languageCode}.json`);
        return module.default;
    } catch (error) {
        return translationSGEN;
    }
}

// Asynchronous function to initialize i18n
async function initializeI18n() {

    // eslint-disable-next-line no-underscore-dangle
    const debugTranslation = window?._env_?.REACT_APP_DEBUG_TRANSLATION || process.env.REACT_APP_DEBUG_TRANSLATION;

    try {
        const translations = await loadTranslations(countryLanguageCodeWithPath.countryCode, countryLanguageCodeWithPath.languageCode);
        // Initialize i18n with the loaded translations
        i18n
            .use(HttpBackend)
            .use(LanguageDetector)
            .use(initReactI18next) // passes i18n down to react-i18next
            .init({
                debug: debugTranslation === DEBUG_TRANSLATION, // Set to true if you want to see logging
                resources: {
                    [countryLanguageCodeWithPath.languageCode ? countryLanguageCodeWithPath.languageCode : DEFAULT_LANGUAGE ]: {
                        translation: translations
                    }
                },
                fallbackLng: DEFAULT_LANGUAGE, // Use 'en' if detected lang is not available
                lng: countryLanguageCodeWithPath.languageCode, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
                // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
                // if you're using a language detector, do not define the lng option
                keySeparator: false, // we do not use keys in form messages.welcome
                interpolation: {
                    escapeValue: false // react already safes from xss
                }
            });
            const isDirRtl = i18n.t('dir') === 'rtl';
            if (isDirRtl && document.body) {
                document.body.setAttribute('dir', 'rtl');
            }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to load translations:', error);
    }
}

// Export a promise that resolves when i18n is initialized
export const i18nInitialized = initializeI18n;

// Optionally, export i18n for immediate use
export default i18n;
